export enum LoginSubPage {
  PIN,
  FORGOT_PIN,
  CREATE_NEW,
  OTP,
}
